import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { AdministradorService } from 'src/app/services/administrador.service';
import { Medico } from 'src/app/models/medico.interface';
import { CasoClinico, CasoClinicoFormatoXLS } from 'src/app/models/caso-clinico.interface';
import { Enfermera } from 'src/app/models/enfermera.interface';
import { RedimirMedico } from 'src/app/models/redimir.interface';
import { Producto } from 'src/app/models/producto.interface';
import { CANJE } from 'src/app/shared/constantes/constants';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { Puntos } from 'src/app/models/catalogos.interface';
@Component({
  selector: 'app-administrador-medico',
  templateUrl: './administrador-medico.component.html',
  styleUrls: ['./administrador-medico.component.scss'],
  providers: [MessageService]
})
export class AdministradorMedicoComponent {
  showModal = false;
  showModalPuntosDefault = false;
  showModalPuntosProducto = false;
  accionPendiente: 'cancelar' | 'rechazar' | null = null;
  accionPendientePuntos: 'cancelar' | 'rechazar' | null = null;
  idMedico: string = '0';
  medico!: Medico;
  producto!: Producto;
  statusCanje: string[] = [...CANJE];
  casoclinicoEnfermera!: CasoClinico;

  catalogoEnfermeras: Enfermera[] = [];
  enfermerasForm!: FormGroup;


  catalogoPuntos: Puntos[] = [];
  puntosForm!: FormGroup;
  puntosProductoForm!: FormGroup;

  currentPageCasosClinicos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCasosClinicos: number = 10;

  currentPageEnfermeras: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsEnfermeras: number = 10;

  currentPageProductos: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsProductos: number = 10;

  currentPageCanjes: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItemsCanjes: number = 10;

  constructor(
    private activedRoute: ActivatedRoute,
    private messageService: MessageService,
    private fb: FormBuilder,
    private router: Router,
    private administradorService: AdministradorService) {
    this.idMedico = this.activedRoute.snapshot.params['id'];
    this.getMedico(this.idMedico);
    this.enfermerasForm = this.crearFormularioEnfermera();
    this.puntosForm = this.crearFormularioPuntos();
    this.puntosProductoForm = this.crearFormularioPuntos();
  }
  get puntosCanjeados(): number {
    return this.medico.redimir.reduce((total, canje) => total + (canje.status == 3 ? canje.redimir : 0), 0);
  }
  get puntosGenerados(): number {
    return this.medico.productos.reduce((total, producto) => total + (producto.m_puntos ? producto.m_puntos : 0), 0);
  }
  get saldo(): number {
    return this.medico.productos.reduce((total, producto) => total + (producto.status_canje != 3 ? (producto.m_puntos ?? 0) : 0), 0);
  }
  get casosclinicos(): CasoClinico[] {
    const startIndex = (this.currentPageCasosClinicos.page) * this.currentPageCasosClinicos.rows;
    return this.medico.casosclinicos.slice(startIndex, startIndex + this.currentPageCasosClinicos.rows);
  }
  get totalPaginasCasosClinicos(): number {
    return Math.ceil(this.medico.casosclinicos.length / this.currentPageCasosClinicos.rows);
  }

  get productos(): Producto[] {
    const startIndex = (this.currentPageProductos.page) * this.currentPageProductos.rows;
    return this.medico.productos.slice(startIndex, startIndex + this.currentPageProductos.rows);
  }
  get totalPaginasProductos(): number {
    return Math.ceil(this.medico.productos.length / this.currentPageProductos.rows);
  }

  get enfermeras(): Enfermera[] {
    const startIndex = (this.currentPageEnfermeras.page) * this.currentPageEnfermeras.rows;
    return this.medico.enfermeras.slice(startIndex, startIndex + this.currentPageEnfermeras.rows);
  }
  get totalPaginasEnfermeras(): number {
    return Math.ceil(this.medico.enfermeras.length / this.currentPageEnfermeras.rows);
  }

  get canjes(): RedimirMedico[] {
    const startIndex = (this.currentPageCanjes.page) * this.currentPageCanjes.rows;
    return this.medico.redimir.slice(startIndex, startIndex + this.currentPageCanjes.rows);;
  }
  get totalPaginasCanjes(): number {
    return Math.ceil(this.medico.redimir.length / this.currentPageCanjes.rows);
  }
  crearFormularioEnfermera(): FormGroup {
    return this.fb.group({
      enfermera: [null, Validators.required]
    })
  }
  crearFormularioPuntos(): FormGroup {
    return this.fb.group({
      puntos: [null, Validators.required],
      id: [null]
    })
  }
  getMedico(id: string): void {
    this.administradorService.getMedico(id)
      .subscribe({
        next: (resp) => {
          this.medico = resp.datos;
          this.catalogoEnfermeras = this.medico.enfermeras;
          this.asignarTotales(resp.datos);
          this.showSuccess(resp.mensaje); console.log(resp.mensaje);
        },
        error: (err: HttpErrorResponse) => { console.log(err) }
      })
  }

  asignarTotales(medico: Medico): void {
    this.totalItemsCasosClinicos = medico.casosclinicos.length;
    this.totalItemsProductos = medico.productos.length;
    this.totalItemsEnfermeras = medico.enfermeras.length;
    this.totalItemsCanjes = medico.redimir.length;
  }
  onPageChangeCasosClinicos(event: any) {
    this.currentPageCasosClinicos = <Paginar>event;
  }
  onPageChangeProductos(event: any) {
    this.currentPageProductos = <Paginar>event;
  }
  onPageChangeEnfermeras(event: any) {
    this.currentPageEnfermeras = <Paginar>event;
  }
  onPageChangeCanjes(event: any) {
    this.currentPageCanjes = <Paginar>event;
  }

  showSuccess(mensaje: string): void {
    this.messageService.add({
      severity: 'success',
      summary: 'Éxito',
      detail: mensaje
    });
  }

  showError(mensaje: string): void {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: mensaje
    });
  }
  getCanje(id: number): string {
    return this.statusCanje[id];
  }
  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const casosClinicos: CasoClinicoFormatoXLS[] = this.fullCasosClinicosXLSX(this.medico.casosclinicos);
    const nombreMedico = [{ campo: "Medico", nomMedico: this.medico.nom_medico }];
    const fileName = 'medico-casosclinicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, nombreMedico, { origin: "A2", skipHeader: true });
      XLSX.utils.sheet_add_json(ws, casosClinicos, { origin: "A4" });
      /* generate workbook and add the worksheet */
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'casos_clinicos');
      /* save to file */

      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  fullCasosClinicosXLSX(casoclinico: CasoClinico[]): CasoClinicoFormatoXLS[] {
    const casosclinicosxlsx: CasoClinicoFormatoXLS[] = casoclinico.map((item) => {
      return <CasoClinicoFormatoXLS>{
        fecha: item.fecha,
        folio: item.folio,
        serie: item.serie,
        paciente: item.paciente,
        sexo: item.sexo,
        edad: item.edad,
        antecedente: item.antecedente,
        institucion: item.cveInstitucion,
        hospital: item.nomHospital,
        fechaAplicacionProducto: item.fechaAplicacionProducto,
        diagnostico: item.diagnostico,
        antibiotico1: item.nomAntibiotico1,
        cantidad1: item.cantidad1,
        antibiotico2: item.nomAntibiotico2,
        cantidad2: item.cantidad2,
        antibiotico3: item.nomAntibiotico3,
        cantidad3: item.cantidad3,
        tratamiento: item.tratamiento,
        cuerpo: item.nomCuerpo,
        observacion: item.observacion,
        enfermera: item.enfermera.nom_enfermera,
        productos: item.productos.length,
        documentos: item.documentos.length
      };
    });
    return casosclinicosxlsx;
  }
  exportPDF(): void { }

  onSubmit(): void {
    const enfermera: Enfermera = this.enfermerasForm.value.enfermera;
    // console.log(enfermera.id, this.casoclinicoEnfermera.id);
    this.administradorService
      .asociarEnfermeraCasoClinico(enfermera.id, this.casoclinicoEnfermera.id)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.casoclinicoEnfermera.fk_enfermera = enfermera.id;
          this.casoclinicoEnfermera.enfermera = enfermera;
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message)
        }
      })

  }

  cancelarAccion(): void {
    this.resetForm();
    //  this.catalogoEnfermeras = [];
    this.closeModal();
  }

  closeModal(): void {
    this.showModal = false;
    this.accionPendiente = null;
  }
  openModal(): void {
    this.accionPendiente = 'rechazar';
    this.showModal = true;
  }
  resetForm(): void {
    this.enfermerasForm.reset();
  }
  onSubmitPuntos(): void {
    const puntos: Puntos = this.puntosForm.get('puntos')?.value;
    const id = this.puntosForm.get('id')?.value;

    this.administradorService.asignarMedicoPuntosDefault(this.medico.id, puntos)
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.medico.puntos = puntos.puntos;
          this.medico.fk_puntos = puntos.id;
          this.closeModalPuntosDafault();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
        }

      })

  }
  onSubmitPuntosProducto(): void {
    const puntos: Puntos = this.puntosProductoForm.get('puntos')?.value;


    const producto: Producto = this.producto;
    this.administradorService.asignarPuntosProducto({ fk_producto: producto.id, puntos: puntos.puntos })
      .subscribe({
        next: (resp) => {
          this.showSuccess(resp.mensaje);
          this.producto.m_puntos = puntos.puntos;
          this.closeModalPuntosProducto();
        },
        error: (err: HttpErrorResponse) => {
          this.showError(err.error.message);
        }

      });
  }
  asignarEnfermera(casoclinico: CasoClinico): void {
    this.openModal();
    this.casoclinicoEnfermera = casoclinico;
  }
  nuevoCanje(): void {
    this.router.navigate(['/administrador/medico/solicitud/canje', this.idMedico]);
  }
  cancelarAccionPuntosDefault(): void {
    this.resetFormPuntos();
    this.closeModalPuntosDafault();
  }
  cancelarAccionPuntosProducto(): void {
    this.resetFormPuntosProducto();
    this.closeModalPuntosProducto();
  }
  openModalPuntosDafault(): void {
    this.accionPendientePuntos = 'rechazar';
    this.showModalPuntosDefault = true;
  }
  closeModalPuntosDafault(): void {
    this.showModalPuntosDefault = false;
    this.accionPendientePuntos = null;
  }
  openModalPuntosProducto(): void {
    this.accionPendientePuntos = 'rechazar';
    this.showModalPuntosProducto = true;
  }
  closeModalPuntosProducto(): void {
    this.showModalPuntosProducto = false;
    this.accionPendientePuntos = null;
  }
  resetFormPuntos(): void {
    this.puntosForm.reset();
  }
  resetFormPuntosProducto(): void {
    this.puntosProductoForm.reset();
  }
  asignarpuntos(medico: Medico): void {

    this.administradorService.catalogoPuntos()
      .subscribe({
        next: (resp) => {
          this.catalogoPuntos = resp;
          this.medico = medico;
          this.openModalPuntosDafault();
        },
        error: (err) => {
          console.log(err);
        }
      });

  }
  asignarpuntosproducto(producto: Producto): void {
    this.administradorService.catalogoPuntos()
      .subscribe({
        next: (resp) => {
          this.catalogoPuntos = resp;
          this.producto = producto;
          this.openModalPuntosProducto();
        },
        error: (err) => {
          console.log(err);
        }
      });

  }
  regresar(): void {
    this.router.navigate(['/administrador/medicos']);
  }
}
